<!--
  Sub-modale "Conferma prodotti" — primo step wizard picking (v2.11.0 J.4.a).
  Diakonix native modal pattern (z-index 2100 sopra page detaggli J.3).

  Drop legacy:
   - kendo-dialog → backdrop fixed + modal centered
   - ion-accordion-group/ion-accordion/ion-item → <details>/<summary> native
   - kendo-dropdownlist → native <select> con qty options
   - kendo-label/kendo-textbox/kendo-numerictextbox → input native
   - 🚨 "AGGIUNGI caca" testo debug rimosso
   - <app-product-detail-modal> in fondo (RIPRISTINATO v2.11.1 — non era dead,
     era usato dal bottone INFO via goToProductDetails → closeServ.prodDetOn)
-->
@if (isProdCheck) {
  <div class="cp-backdrop" (click)="close()">
    <div
      class="cp-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cp-title"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <header class="cp-header">
        <div class="cp-title-block">
          <h2 id="cp-title">📦 Seleziona i prodotti</h2>
          @if (order?.or_order_number) {
            <p class="cp-subtitle">
              Ordine n° <strong>{{ order.or_order_number }}</strong>
            </p>
          }
        </div>
        <button
          type="button"
          class="cp-close"
          aria-label="Chiudi"
          (click)="close()"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>

      <!-- Toolbar -->
      <div class="cp-toolbar">
        <button
          type="button"
          class="cp-btn cp-btn--select-all"
          (click)="selectAll()"
        >
          <i class="bx bx-check-circle"></i>
          Seleziona tutti
        </button>

        @if (!isDDT) {
          <button
            type="button"
            class="cp-btn cp-btn--add"
            (click)="addNewProduct()"
          >
            <i class="bx bx-plus-circle"></i>
            Aggiungi prodotto
          </button>
        }
      </div>

      <!-- Body: lista prodotti + similar products panel -->
      <div class="cp-body">
        <!-- ===== Lista prodotti ===== -->
        <section class="cp-products" [class.cp-products--narrow]="openedSearch">
          @for (prod of order?.products; track prod.products_order_id; let i = $index) {
            <!-- Prodotto con sub-products → accordion -->
            @if (prod?.sub_products?.length > 0) {
              <details
                class="cp-product"
                [class.cp-product--checked]="prod.op_checked"
                [open]="activeAccordion === 'accordion-' + i"
                (toggle)="handleToggle($event, 'accordion-' + i)"              
              >
                <summary class="cp-product-row">
                  <div class="cp-product-info">
                    <span class="cp-product-desc">{{ prod.op_description }}</span>
                    <span class="cp-product-code">{{ prod.op_code }}</span>
                  </div>

                  <div class="cp-product-actions" (click)="$event.stopPropagation()">
                    @if (!isDDT) {
                      <select
                        class="cp-qty-select"
                        [(ngModel)]="prod.op_qta_picked"
                        (ngModelChange)="updateProduct(prod.op_qta_picked, i)"
                        (click)="changeProductNumber(prod.op_qta); $event.stopPropagation()"
                      >
                        <option [ngValue]="null">--</option>
                        @for (n of numbers; track n) {
                          <option [ngValue]="n">{{ n }}</option>
                        }
                      </select>
                    }
                    <span class="cp-qty-total">{{ prod.op_qta }} pz</span>

                    @if (!isDDT) {
                      <button
                        type="button"
                        class="cp-icon-btn cp-icon-btn--replace"
                        title="Sostituisci prodotto"
                        aria-label="Sostituisci prodotto"
                        (click)="selectProduct(prod, i)"
                      >
                        <i class="bx bx-plus-circle"></i>
                      </button>
                      <button
                        type="button"
                        class="cp-icon-btn cp-icon-btn--delete"
                        title="Elimina prodotto"
                        aria-label="Elimina prodotto"
                        (click)="deleteProduct(prod, i)"
                      >
                        <i class="bx bxs-trash-alt"></i>
                      </button>
                    }
                    <button
                      type="button"
                      class="cp-icon-btn cp-icon-btn--info"
                      title="Info prodotto"
                      aria-label="Info prodotto"
                      (click)="goToProductDetails(prod.op_code)"
                    >
                      <i class="bx bx-info-circle"></i>
                    </button>
                    @if (prod.barcodes?.length > 0) {
                      <button
                        type="button"
                        class="cp-icon-btn cp-icon-btn--qr"
                        title="Codici QR"
                        aria-label="Codici QR"
                        (click)="seeQrCodes(prod, order)"
                      >
                        <i class="bx bx-qr"></i>
                      </button>
                    }
                  </div>
                </summary>

                <!-- Sub-products -->
                <div
                  class="cp-subproducts"
                  [class.cp-subproducts--all-checked]="areAllSubProductsChecked"
                >
                  @for (subProd of prod?.sub_products; track $index; let j = $index) {
                    <div
                      class="cp-subproduct"
                      [class.cp-subproduct--checked]="subProd.osp_checked"
                    >
                      <div class="cp-subproduct-info">
                        <span class="cp-subproduct-desc">{{ subProd.osp_description }}</span>
                        <span class="cp-subproduct-code">{{ subProd.osp_code }}</span>
                      </div>
                      <div class="cp-subproduct-meta">
                        <span class="cp-subproduct-qty">
                          <strong>{{ subProd.osp_qty_picked }}</strong>
                          /
                          <span>{{ subProd.osp_qty_ordered }}</span>
                          <span class="cp-qty-unit">pz</span>
                        </span>
                        @if (hasValidBarcodesSub(subProd)) {
                          <button
                            type="button"
                            class="cp-icon-btn cp-icon-btn--qr"
                            title="Codici QR sub-prodotto"
                            aria-label="Codici QR sub-prodotto"
                            (click)="seeQrCodesSub(subProd, order)"
                          >
                            <i class="bx bx-qr"></i>
                          </button>
                        }
                      </div>
                    </div>
                  }
                </div>
              </details>
            }

            <!-- Prodotto senza sub-products → row plain -->
            @if (!prod?.sub_products?.length) {
              <div
                class="cp-product cp-product--plain"
                [class.cp-product--checked]="prod.op_checked"
                (click)="opChecked(prod, i)"
              >
                <div class="cp-product-info">
                  <span class="cp-product-desc">{{ prod.op_description }}</span>
                  <span class="cp-product-code">{{ prod.op_code }}</span>
                </div>
                <div class="cp-product-actions" (click)="$event.stopPropagation()">
                  @if (!isDDT) {
                    <select
                      class="cp-qty-select"
                      [(ngModel)]="prod.op_qta_picked"
                      (ngModelChange)="updateProduct(prod.op_qta_picked, i)"
                      (click)="changeProductNumber(prod.op_qta)"
                    >
                      <option [ngValue]="null">--</option>
                      @for (n of numbers; track n) {
                        <option [ngValue]="n">{{ n }}</option>
                      }
                    </select>
                  }
                  <span class="cp-qty-total">{{ prod.op_qta }} pz</span>

                  @if (!isDDT) {
                    <button
                      type="button"
                      class="cp-icon-btn cp-icon-btn--replace"
                      title="Sostituisci prodotto"
                      aria-label="Sostituisci prodotto"
                      (click)="selectProduct(prod, i)"
                    >
                      <i class="bx bx-plus-circle"></i>
                    </button>
                    <button
                      type="button"
                      class="cp-icon-btn cp-icon-btn--delete"
                      title="Elimina prodotto"
                      aria-label="Elimina prodotto"
                      (click)="deleteProduct(prod, i)"
                    >
                      <i class="bx bxs-trash-alt"></i>
                    </button>
                  }
                  <button
                    type="button"
                    class="cp-icon-btn cp-icon-btn--info"
                    title="Info prodotto"
                    aria-label="Info prodotto"
                    (click)="goToProductDetails(prod.op_code)"
                  >
                    <i class="bx bx-info-circle"></i>
                  </button>
                  @if (hasValidBarcodes(prod)) {
                    <button
                      type="button"
                      class="cp-icon-btn cp-icon-btn--qr"
                      title="Codici QR"
                      aria-label="Codici QR"
                      (click)="seeQrCodes(prod, order)"
                    >
                      <i class="bx bx-qr"></i>
                    </button>
                  }
                </div>
              </div>
            }
          }
        </section>

        <!-- ===== Search panel (Aggiungi/Sostituisci prodotto) ===== -->
        @if (openedSearch) {
          <section class="cp-search">
            <header class="cp-search-header">
              <h3>{{ isSimilar ? '🔄 Sostituisci prodotto' : '➕ Aggiungi prodotto' }}</h3>
              <button
                type="button"
                class="cp-close cp-close--inline"
                aria-label="Chiudi pannello ricerca"
                (click)="openedSearch = false"
              >
                <i class="bx bx-x"></i>
              </button>
            </header>

            <div class="cp-search-input-wrap">
              <span class="cp-search-icon">🔍</span>
              <input
                type="search"
                class="cp-search-input"
                [(ngModel)]="filterTerm"
                (keyup.enter)="getSimilarProducts()"
                placeholder="Cerca prodotto..."
                autofocus
              />
              <button
                type="button"
                class="cp-btn cp-btn--search"
                (click)="getSimilarProducts()"
              >
                Cerca
              </button>
            </div>

            @if (similarProducts?.length > 0) {
              <div class="cp-similar-list">
                @for (product of similarProducts; track $index; let i = $index) {
                  <button
                    type="button"
                    class="cp-similar-item"
                    [class.cp-similar-item--checked]="product.pr_checked"
                    (click)="selectProductToAdd(i)"
                  >
                    @if (product.pr_checked) {
                      <i class="bx bxs-check-circle cp-check-icon"></i>
                    } @else {
                      <i class="bx bx-check-circle cp-check-icon"></i>
                    }
                    <span class="cp-similar-desc" [title]="product.pr_description">
                      {{ product.pr_description | slice: 0 : 60 }}{{ product.pr_description.length > 60 ? '...' : '' }}
                    </span>
                  </button>
                }
              </div>
            }

            @if (!isSimilar) {
              <div class="cp-add-fields">
                <label class="cp-field">
                  <span class="cp-field-label">Quantità</span>
                  <input
                    type="number"
                    class="cp-field-input"
                    [(ngModel)]="quantity"
                    min="1"
                  />
                </label>
                <label class="cp-field">
                  <span class="cp-field-label">Nota</span>
                  <input
                    type="text"
                    class="cp-field-input"
                    [(ngModel)]="pr_note"
                    placeholder="Nota opzionale"
                  />
                </label>
              </div>
            }

            @if (isAnyChecked) {
              <button
                type="button"
                class="cp-btn cp-btn--add cp-btn--full"
                (click)="addProduct()"
              >
                <i class="bx bx-check-circle"></i>
                {{ isSimilar ? 'Cambia prodotto' : 'Aggiungi prodotto' }}
              </button>
            }
          </section>
        }
      </div>

      <!-- Footer Save -->
      <footer class="cp-footer">
        <button
          type="button"
          class="cp-btn cp-btn--save"
          (click)="saveStep('products')"
        >
          <i class="bx bx-check-circle"></i>
          Salva selezione
        </button>
      </footer>
    </div>
  </div>
}

<!-- Sub-modali QR codes (z-index 2200 — sopra cp-modal 2100) -->
@if (closeServ.isQRProducts) {
  <app-products-qrcodes
    [openedQRS]="closeServ.isQRProducts"
    [product]="barcodes"
    [order]="this.order"
  ></app-products-qrcodes>
}

@if (closeServ.isQRSubProducts) {
  <app-subproduct-qrcode
    [openedSubQrs]="closeServ.isQRSubProducts"
    [subProduct]="barcodes"
    [order]="this.order"
  ></app-subproduct-qrcode>
}

<!--
  🚨 FIX v2.11.1 (#1): pulsante INFO sui prodotti chiamava goToProductDetails()
  che setta closeServ.prodDetOn() ma in J.4.a avevo rimosso erroneamente
  questo include considerandolo dead (era invece il consumer del flag).
  Modal Diakonix-restyled in v2.9.0 polish (#190).
-->
@if (closeServ.isProdDetOn) {
  <app-product-detail-modal
    [opened]="closeServ.isProdDetOn"
    [pr_code]="clickedProduct"
  ></app-product-detail-modal>
}
